module.exports = __webpack_public_path__ + "img/perks_A FamDay.1b35d1b7.jpg";